<template>
  <div class="inline-preview">
    <div class="json" v-if="message.native.payload_type === 'json'">
      <vue-json-pretty :path="'res'" :data="inlineJsonFormatted" />
    </div>
    <div class="raw" v-if="message.native.payload_type === 'raw'">
      <div v-if="message.native.payload.raw === ''" />
      <div
        v-else-if="
          message.native.payload.raw && isJson(message.native.payload.raw)
        "
      >
        <vue-json-pretty
          :path="'res'"
          :data="JSON.parse(message.native.payload.raw)"
        />
      </div>
      <div v-else class="invalid-json">
        {{ $t('CampaignForm_NativeInline_Preview_InvalidJSON') }}
      </div>
    </div>
    <div class="form" v-if="message.native.payload_type === 'form'">
      <div v-if="message.native.payload.form === ''" />
      <div
        v-else-if="
          message.native.payload.form &&
            isJson(templateToJson(message.native.payload.form).string)
        "
      >
        <vue-json-pretty
          :path="'res'"
          :data="templateToJson(message.native.payload.form).object"
        />
      </div>
      <div v-else class="invalid-json">
        {{ $t('CampaignForm_NativeInline_Preview_InvalidJSON') }}
      </div>
    </div>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'

export default {
  name: 'NativeInlinePreview',

  components: { VueJsonPretty },

  props: {
    message: {
      type: Object,
      required: true
    }
  },

  computed: {
    inlineJsonFormatted() {
      let obj = {}
      this.message.native.payload.json.map(item => {
        obj[item.key] = item.value
      })
      return obj
    }
  },

  methods: {
    isJson(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },

    templateToJson(payload) {
      let escapedPayload = ''
      let payloadParts = payload.split(/({{.*?}})/g)
      payloadParts.forEach(function(part) {
        if (/^{{\s?field\[/.test(part) && /\]\s?}}$/.test(part)) {
          if (escapedPayload[escapedPayload.length - 1] === '"') {
            escapedPayload += part
          } else {
            escapedPayload += '"' + part.replaceAll('"', '\\"') + '"'
          }
          return
        }
        if (typeof part === 'object') {
          escapedPayload += JSON.stringify(part)
        } else {
          escapedPayload += part
        }
      })
      try {
        return { object: JSON.parse(escapedPayload), string: escapedPayload }
      } catch (e) {
        return {}
      }
    }
  }
}
</script>

<style scoped lang="scss">
.inline-preview {
  /* Scrollbar */

  /* width */
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    width: 5px;
    background: #7e8596;
    border-radius: 5px;
  }

  padding: 10px;
  background: white;
  height: 100%;
  overflow: auto;
  .raw,
  .form,
  .json {
    width: max-content;
    min-width: 100%;
  }
}
.invalid-json {
  color: #b94a48;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/channels/NativeInlinePreview.vue